<template>
  <header
    class="SearchGalleryHeader">
    <BaseInput
      class="SearchGalleryHeader_SearchBar"
      :value="searchText"
      :height="48"
      no-border
      :disabled="isLoading"
      placeholder="Search"
      icon="search"
      show-clear-text
      @input="handleSearchInput"
    />

    <div
      v-if="!isLoading"
      class="SearchGalleryHeader_Chips"
      key="SGH-filter-chips">
      <BaseChip
        v-for="activeFilter in activeFilters"
        :key="activeFilter.value"
        @click="$emit('filter-input', activeFilter.groupKey, activeFilter)">
        {{ activeFilter.label }}
      </BaseChip>
    </div>

    <div
      class="SearchGalleryHeader_SortBar">
      <div>
        <h3
          class="SearchGalleryHeader_result-count">
          {{ resultsText }}
          <transition
            name="fade">
            <BaseLoader
              class="SearchGalleryHeader_results-loader"
              v-show="isSearching || isLoading"
            />
          </transition>
        </h3>

        <BaseButton
          class="SearchGalleryHeader_FilterBtn"
          theme="ghost"
          @click="$emit('filter-menu-btn-click')">
          FILTER
        </BaseButton>
      </div>

      <BaseSelect
        v-if="sortOptions && !isLoading"
        class="SearchGalleryHeader_SortSelect"
        anchor="right"
        ghost
        :options="sortOptions"
        :value="computedSortValue"
        key="SGH-sort-select"
        @input="handleSort"
      />
    </div>
  </header>
</template>

<script>
import BaseInput from '@/components/BaseInput.vue';
import BaseSelect from '@/components/BaseSelect.vue';
import BaseChip from '@/components/BaseChip.vue';
import BaseLoader from '@/components/BaseLoader.vue';
import BaseButton from '@/components/BaseButton.vue';

export default {
  name: 'SearchGalleryHeader',

  components: {
    BaseInput,
    BaseSelect,
    BaseChip,
    BaseLoader,
    BaseButton,
  },

  props: {
    searchText:    { type: String,  default: '' },
    isLoading:     { type: Boolean, default: true },
    isSearching:   { type: Boolean, default: false },
    activeFilters: { type: Array,   default: () => [] },
    resultsText:   { type: String,  default: '' },
    sortOptions:   { type: Array,   default: null },
    sortValue:     { type: Object,  default: null },
  },

  computed: {
    computedSortValue() {
      if (!this.sortValue) return null;
      return this.sortValue.value;
    },
  },

  methods: {
    handleSearchInput(text) {
      this.$emit('search', text);
    },

    handleSort(newSortValue) {
      const newEmittedSortValue = this.sortOptions
        .find((sortOption) => (sortOption.value === newSortValue));

      this.$emit('sort', newEmittedSortValue);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/_variables';

.SearchGalleryHeader_SearchBar {
  margin-bottom: 16px;
  box-shadow: 0 3px 6px rgba($black, .2);
}

.SearchGalleryHeader_SortBar {
  display: flex;
  margin-top: 8px;
  justify-content: space-between;
  align-items: center;
}

.SearchGalleryHeader_FilterBtn {
  display: none;
  margin-left: -16px;
  color: $dark-blue;
}

.SearchGalleryHeader_SortSelect {
  color: $dark-blue;
  text-transform: uppercase;
  font-weight: bold;
}

.SearchGalleryHeader_result-count {
  line-height: 24px;
}

.SearchGalleryHeader_results-loader {
  display: inline-block;
  position: relative;
  top: -1px;
  margin-left: 8px;
  vertical-align: middle;
}

@media only screen and (max-width: 640px) {
  .SearchGalleryHeader_SearchBar {
    margin-bottom: 8px !important;
  }

  .SearchGalleryHeader_FilterBtn {
    display: block !important;
  }

  .SearchGalleryHeader_SortBar {
    align-items: flex-end !important;
  }
}
</style>
